import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面未找到 - 爆料大赛赛程站",
    description: "你访问的页面不存在，可以返回首页查看爆料大赛赛程时间表、活动安排与比赛进度。",
    keywords: "爆料大赛,爆料大赛赛程,爆料大赛时间表",
    path: "/404",
    robots: "noindex, follow",
  });

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 pt-32 md:pt-40 pb-24 flex flex-col items-center text-center">
        <span className="font-heading text-7xl md:text-9xl font-bold text-background-300 select-none">404</span>
        <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">没有找到这个页面</h1>
        <p className="mt-4 max-w-lg text-sm md:text-base text-foreground-600 leading-relaxed">
          你访问的路径 <span className="text-foreground-800">{location.pathname}</span> 不存在或已经调整。可以回到首页，从赛程时间表开始查看。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/schedule"
            className="px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看赛程时间表
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}